/**
 * Stable key for `subscriptions_custom.marketing_lines.<slug>` from Stripe
 * `marketing_features[].name` (English). Add the same slug under en.json and uk.json.
 */
export function marketingLineSlug(name: string): string {
  if (!name || typeof name !== 'string') {
    return ''
  }
  let s = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/_{2,}/g, '_')
  if (/^[0-9]/.test(s)) {
    s = `s_${s}`
  }
  return s
}

/**
 * Stripe `marketing_features` is normally `{ name: string }[]`, but a single object
 * `{ name }` appears on some paths — wrap so *ngFor always gets an array.
 */
export function normalizeStripeMarketingFeatures(mf: unknown): { name: string }[] {
  if (mf == null) {
    return []
  }
  if (typeof mf === 'string') {
    return [{ name: mf }]
  }
  if (Array.isArray(mf)) {
    return mf.map((item) => {
      if (typeof item === 'string') {
        return { name: item }
      }
      if (item && typeof item === 'object' && 'name' in item) {
        const n = (item as { name: unknown }).name
        return { name: typeof n === 'string' ? n : String(n ?? '') }
      }
      return { name: String(item) }
    })
  }
  if (typeof mf === 'object' && mf !== null && 'name' in mf && typeof (mf as { name: unknown }).name === 'string') {
    return [{ name: (mf as { name: string }).name }]
  }
  return []
}

